import React from 'react';

export default function DedicatedTeamsIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.7749 2.99999L0 4.92694L0.580191 10.5799L19.3551 8.65298L18.7749 2.99999Z" fill="#F66135" />
      <path d="M19.3483 14.821L0.513672 16.0324L0.878409 21.7034L19.713 20.492L19.3483 14.821Z" fill="#FBB39E" />
      <path d="M20.2309 9.72357H1.35742V15.4063H20.2309V9.72357Z" fill="#FBB39E" />
    </svg>
  );
}
